import { gql } from "@apollo/client";

export default gql`
  mutation cancelJob($data: DeleteJobInput!) {
    cancelJob(data: $data)
  }
`;
